import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Actions from 'modules/core/components/Sidepanel/_Action'
import * as styles from 'modules/core/components/Sidepanel/index.vanilla.css'
import i18n from 'modules/core/lib/i18n'

const CloseButton = ({ onClose }: { onClose: () => void }) => (
  <button
    type="button"
    onClick={(event) => {
      event.stopPropagation()
      onClose?.()
    }}
    aria-label={i18n.t('expenses_v2.modals.detail.actions.close_detail')}
  >
    <Button.Decorative type="secondary" iconName="cross" />
  </button>
)

const Title = () => (
  <Box alignItems="center" justifyContent="center" flexDirection="row" flexGrow>
    <Text size="300" color="textPrimary" weight="semibold">
      {i18n.t('finance.invoices.detail.navigator.title')}
    </Text>
  </Box>
)

export const Header = ({
  onDelete,
  onClose,
  canDelete = false,
}: {
  onDelete?: () => void
  onClose: () => void
  canDelete?: boolean
}) => {
  const options = [
    ...(canDelete && onDelete
      ? [
          {
            title: i18n.t('finance.invoices.actions.delete_invoice'),
            onClick: onDelete,
            danger: true,
          },
        ]
      : []),
  ]

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s16"
      paddingX="s24"
      className={styles.Header}
    >
      <CloseButton onClose={onClose} />
      <Title />
      {options.length > 0 && <Actions options={options} />}
    </Box>
  )
}
